export enum RegistryTypes {
  MsgExec = '/cosmos.authz.v1beta1.MsgExec',
  MsgCyberlink = '/cyber.graph.v1beta1.MsgCyberlink',
}
